import PropTypes from "prop-types";
import { makeStyles } from "tss-react/mui";
import { Box, Typography } from "@mui/material";
import { MiLoader } from "../MiLoader/MiLoader";

export function MiPageHeader({
  title,
  color,
  leftIcon,
  details,
  rightArea,
  action,
  hasDivider,
  containerStyles,
  subTitles = [],
  titleVariant = "h5",
  loading = false,
}) {
  const { classes } = useStyles({
    hasDivider,
    containerStyles,
    color,
    leftIcon,
  });

  const renderSubtitles = () => (
    <Box className={classes.subTitlesContainer}>
      {subTitles?.map((title, index) => (
        <Box className={classes.subtitleWithDivider} key={`title-${index}`}>
          <Typography>{title}</Typography>
        </Box>
      ))}
    </Box>
  );

  return (
    <Box id="mipageheader" data-testid="MiPageHeader">
      <Box className={classes.container}>
        <Box className={classes.detailContainer}>
          <Box className={classes.leftContainer}>
            <Box display="flex" sx={{ cursor: "pointer" }}>
              {leftIcon}
            </Box>
            <Box>
              <Typography
                className={classes.typographyStyle}
                variant={titleVariant}
              >
                <span>&nbsp;</span>
                {title}
              </Typography>
              <Box className={classes.detailContainer}>{details}</Box>
            </Box>
            {subTitles.length > 0 && renderSubtitles()}
          </Box>
          {rightArea}
          {action}
        </Box>
      </Box>
      <MiLoader isLoading={loading} type="linear" />
    </Box>
  );
}

const useStyles = makeStyles()(
  (theme, { hasDivider, containerStyles, color, leftIcon }) => ({
    container: {
      justifyContent: "space-between",
      borderBottom: hasDivider
        ? `1px solid ${theme.palette.grey.lightAccent}`
        : "none",
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(4),
      position: "sticky",
      ...containerStyles,
    },
    typographyStyle: {
      color,
      paddingLeft: leftIcon ? "0px" : "none",
      fontWeight: theme.fontWeight.bold,
    },
    detailContainer: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    leftContainer: {
      display: "flex",
      alignItems: "center",
    },
    subTitlesContainer: {
      display: "flex",
      flexDirection: "row",
    },
    subtitleWithDivider: {
      paddingLeft: theme.spacing(4),
      borderLeft: `1px solid ${theme.palette.grey.main}`,
      marginLeft: theme.spacing(4),
      fontSize: theme.fontSize.medium,
      color: theme.palette.grey.main,
    },
  })
);

MiPageHeader.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  leftIcon: PropTypes.element,
  details: PropTypes.element,
  action: PropTypes.element,
  hasDivider: PropTypes.bool,
  containerStyles: PropTypes.object,
  titleVariant: PropTypes.string,
};
